export enum TrackerIntegrationProviders {
	GITLAB = 'GITLAB',
	GITHUB = 'GITHUB',
	JIRA_CLOUD = 'JIRA_CLOUD',
	JIRA_HOSTED = 'JIRA_HOSTED',
	BITBUCKET_CLOUD = 'BITBUCKET_CLOUD',
	TRELLO = 'TRELLO',
}
